import { render, staticRenderFns } from "./CommodityFlowStateInitDetail.vue?vue&type=template&id=8e276aae&scoped=true&"
import script from "./CommodityFlowStateInitDetail.vue?vue&type=script&lang=js&"
export * from "./CommodityFlowStateInitDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e276aae",
  null
  
)

export default component.exports